import { Schema } from "effect";
import { OpenApiClass } from "../openapi-class.js";

const NullableText = Schema.NullOr(Schema.String);
const NullableInteger = Schema.NullOr(Schema.Int);

/** Allowlisted AFR facts at the external-data boundary; unknown is distinct from zero. */
export class WorkplaceSourceFacts extends OpenApiClass<WorkplaceSourceFacts>(
  "WorkplaceSourceFacts"
)({
  source: Schema.Literal("scb_afr"),
  mappingVersion: Schema.Literal(1),
  industryClassification: Schema.Literal("SNI 2025"),
  industries: Schema.Array(
    Schema.Struct({
      code: Schema.String.pipe(Schema.check(Schema.isPattern(/^\d{5}$/u))),
      rank: Schema.Int.pipe(Schema.check(Schema.isGreaterThan(0))),
      percentage: NullableInteger,
      sectionCode: NullableText,
      label: NullableText,
    })
  ),
  postalAddress: Schema.NullOr(
    Schema.Struct({
      street: NullableText,
      postalCode: NullableText,
      city: NullableText,
    })
  ),
  geography: Schema.NullOr(
    Schema.Struct({
      // Preserve the named source pairs. Exact CRS/axis semantics need confirmation
      // before deriving a display point or distance; SWEREF99 is a system family.
      northCoordinateSW: NullableInteger,
      eastCoordinateSW: NullableInteger,
      addressNorthCoordinateSW: NullableInteger,
      addressEastCoordinateSW: NullableInteger,
      localityTypeCode: NullableText,
      localityTypeText: NullableText,
      localityCode: NullableText,
      localityName: NullableText,
    })
  ),
  auxiliaryActivityCode: NullableInteger,
  statusCode: Schema.Int,
  typeCode: Schema.Int,
  employeeSizeClassCode: Schema.Int,
  visitPostalCode: NullableText,
  startDate: NullableText,
  endDate: NullableText,
}) {}
